<template>
    <div>
        <a-row>
            <a-col :span="1"/>
            <a-col :span="8">
                周转箱：
                <a-input style="width: calc(100% - 100px)" v-model="box"/>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="selectList">
                    查询
                </a-button>
            </a-col>
            <a-col :span="4">
                <a-button type="primary" @click="addBox">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" bordered :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;color:red" @click="delBox(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible"
                 title="周转箱信息"
                 width="60%"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="getData">
            <a-row>
                <a-col :span="3"/>
                <a-col :span="4">
                    <b>序号：</b>
                </a-col>
                <a-col :span="13">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    <b>周转箱名称：</b>
                </a-col>
                <a-col :span="13">
                    <a-input v-model.trim="form.name"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    <b>周转箱RFID号：</b>
                </a-col>
                <a-col :span="13">
                    <a-input v-model.trim="form.rfidNo"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    <b>周转箱状态：</b>
                </a-col>
                <a-col :span="13">
                    <a-input v-model.trim="form.status"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    <b>所属机构：</b>
                </a-col>
                <a-col :span="13">
                    <my-select :select-value.sync="form.organId" :data-list="org"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    <b>皮重：</b>
                </a-col>
                <a-col :span="13">
                    <a-input v-model.trim="form.tareWeight"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="3"/>
                <a-col :span="4">
                    <b>医废种类：</b>
                </a-col>
                <a-col :span="13">
                    <my-select :select-value.sync="form.type" :data-list="type"/>
                </a-col>
            </a-row>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {getBoxQueryList, boxEditDetail, boxDelDetail, getOrgQueryList} from './js/ApiBasic';
    import {getTypeQueryList} from '../system/js/ApiSystem'

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '周转箱名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '周转箱RFID号',
            dataIndex: 'rfidNo',
            key: 'rfidNo',
            ellipsis: true,
        },
        {
            title: '周转箱状态',
            dataIndex: 'status',
            key: 'status',
            ellipsis: true,
        },
        {
            title: '周转箱所属机构',
            dataIndex: 'organ.name',
            key: 'organ.name',
            ellipsis: true,
        },
        {
            title: '皮重',
            dataIndex: 'tareWeight',
            key: 'tareWeight',
            ellipsis: true,
        },
        {
            title: '医废种类',
            dataIndex: 'goodsType.name',
            key: 'goodsType.name',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    export default {
        data() {
            return {
                columns,
                box: '',
                visible: false,
                delVisible: false,
                data: {},
                lines: {},
                type: [],
                org: [],
                form: {
                    orderNo: '',
                    name: '',
                    rfidNo: '',
                    status: '',
                    organId: '',
                    grossWeight: '',
                    tareWeight: '',
                    netWeight: '',
                    type: '',
                },
            }
        },
        methods: {
            // 查询设备信息
            selectList() {
                this.getData({name: this.box});
            },
            // 新增按钮
            addBox() {
                this.visible = true;
            },
            //新增-点击确定
            add() {
                this.form.orderNo = this.form.orderNo + '';
                boxEditDetail(this.form).then(() => {
                    this.visible = false;
                    this.getData()
                }).catch(res => {
                    this.visible = false;
                    console.log(res)
                })
            },
            // 编辑按钮
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.visible = true
            },
            //删除按钮
            del(row) {
                boxDelDetail({id: row.id}).then(() => {
                    this.getData();
                });
            },
            getData(parameter) {
                if (!parameter) {
                    parameter = {}
                }
                this.resetForm();
                this.visible = false;
                getBoxQueryList(parameter).then(res => {
                    this.data = res.data;
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                this.form = {
                    orderNo: '',
                    name: '',
                    rfidNo: '',
                    status: '',
                    organId: '',
                    grossWeight: '',
                    tareWeight: '',
                    netWeight: '',
                    type: '',
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                getBoxQueryList({baseDto: baseDto}).then(res => {
                    this.data = res.data;
                })
            },
            // 删除按钮
            delBox(row) {
                this.lines = row;
                this.delVisible = true;
            },
            // 删除提示
            delOk() {
                this.delVisible = false;
                this.del(this.lines);
            },
            cancel() {
                this.delVisible = false;
            },
        },
        created() {
            this.getData();
            getTypeQueryList({}).then(res => {
                this.type = res.data.data;
            });
            getOrgQueryList({}).then(res => {
                this.org = res.data.data;
            });
        }
    }
</script>

<style scoped>
    .Tips {
        font-size: 25px;
        color: #1890ff;
    }

    b {
        float: right;
        padding: 4px
    }
</style>
